import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { classNames } from "../../helpers";
import { loadingState } from "../../redux/reducers/loadingReducer";
import TwButton from "./TwButton";
import { useTranslation } from "react-i18next";

export default function TwWizard(props) {
  const { steps, className = "", showSteps = true } = props
  const { t, i18n } = useTranslation();
  const loadingReduxState = useSelector(loadingState);
  const [step, setStep] = useState(0);
  const [currentStepData, setCurrentStepData] = useState({});
  const totalSteps = steps.length;

  const nextStep = () => setStep((prev) => Math.min(prev + 1, totalSteps - 1));
  const skipStep = () => setStep(totalSteps - 1);
  const prevStep = () => setStep((prev) => Math.max(prev - 1, 0));

  useEffect(() => {
    setCurrentStepData(steps[step])
  }, [steps, step])


  return (
    <div className={classNames("w-full max-w-3xl mx-auto px-4 py-12", className)}>
      {/* Progress Dots */}
      {showSteps && (<nav aria-label="Progress" className="">
        <ol className="[space-y-4] [md:] flex [md:] space-x-8 [md:] space-y-0">
          {steps.map((_, index) => {
            let status = ""
            if (step === index) {
              status = "current"
            }
            if (step > index) {
              status = "complete"
            }

            return (
              <li key={_.name} className="[md:] flex-1">
                {status === 'complete' ? (
                  <a
                    href={_.href}
                    // className="group flex flex-col border-l-4 border-indigo-bz py-2 pl-4 hover:border-indigo-bz-hover md:border-l-0 md:border-t-4 md:pb-0 md:pl-0 md:pt-4"
                    className="group flex flex-col border-indigo-bz py-2 hover:border-indigo-bz-hover border-l-0 border-t-4 pb-0 pl-0 pt-4"
                  >
                    <span className="hidden sm:flex text-sm font-medium text-indigo-bz group-hover:text-indigo-bz-hover">{_.name}</span>
                    {/* <span className="text-sm font-medium">{_.name}</span> */}
                  </a>
                ) : status === 'current' ? (
                  <a
                    href={_.href}
                    aria-current="step"
                    className="flex flex-col border-indigo-bz py-2 border-l-0 border-t-4 pb-0 pl-0 pt-4"
                  >
                    <span className="hidden sm:flex text-sm font-medium text-indigo-bz">{_.name}</span>
                    {/* <span className="text-sm font-medium">{_.name}</span> */}
                  </a>
                ) : (
                  <a
                    href={_.href}
                    className="group flex flex-col border-gray-200  hover:border-gray-300 border-l-0 border-t-4 pb-0 pl-0 pt-4"
                  >
                    <span className="hidden sm:flex text-sm font-medium text-gray-500 group-hover:text-gray-700">{_.name}</span>
                    {/* <span className="text-sm font-medium">{_.name}</span> */}
                  </a>
                )}
              </li>
            )
          })}
        </ol>
      </nav>)}

      {/* Step Content */}
      <div className="py-10 md:py-12">
        {steps.map((_, index) => (
          <div
            key={index}
            className={`${step === index ? "" : "hidden"}`}
            show={step === index}
          >
            {_.content}
          </div>
        ))}
        {/* {steps.map((_, index) => (
          <Transition
            key={index}
            show={step === index}
            enter="transition-opacity duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="transition-opacity duration-300"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            {_.content}
          </Transition>
        ))} */}
      </div>

      {/* Navigation Buttons */}
      <div className="mt-6 flex justify-between">
        <div>
          {/* {currentStepData?.showSkip !== undefined && currentStepData?.showSkip === true && <TwButton
            variant="ghost"
            onClick={async () => {
              if (currentStepData?.onSkipClick !== undefined) {
                let returnonSkipClick = await currentStepData?.onSkipClick()
                if (returnonSkipClick === true) {
                  nextStep()
                }
              } else {
                nextStep()
              }
            }}>Skip</TwButton>} */}
        </div>
        <div className="flex gap-4">
          {currentStepData?.showSkip !== undefined && currentStepData?.showSkip === true && <TwButton
            variant="ghost"
            onClick={async () => {
              if (currentStepData?.onSkipClick !== undefined) {
                let returnonSkipClick = await currentStepData?.onSkipClick()
                if (returnonSkipClick === true) {
                  nextStep()
                }
              } else {
                nextStep()
              }
            }}>{currentStepData?.skipBtnText ? currentStepData?.skipBtnText : t("inputFieldsTitle.skip")}</TwButton>}
          {(currentStepData?.showBack === undefined || (currentStepData?.showBack !== undefined && currentStepData?.showBack === true)) && step > 0 && <TwButton className="sm:min-w-32 [md:w-full]" disabled={loadingReduxState.actionLoading} onClick={prevStep} variant="outline">{currentStepData?.backBtnText ? currentStepData?.backBtnText : t("inputFieldsTitle.back")}</TwButton>}
          {step < totalSteps - 1 ? (
            <TwButton
              className="sm:min-w-32 [md:w-full]"
              variant={"secondary"}
              disabled={loadingReduxState.actionLoading}
              actionLoading={(loadingReduxState.actionLoading)}
              onClick={async () => {
                if (currentStepData?.onNextClick !== undefined) {
                  let returnonNextClick = await currentStepData?.onNextClick()
                  if (returnonNextClick === true) {
                    nextStep()
                  }
                } else {
                  nextStep()
                }
              }}>{currentStepData?.nextBtnText ? currentStepData?.nextBtnText : t("inputFieldsTitle.next")}</TwButton>
          ) : (
            <TwButton
              className="sm:min-w-32 [md:w-full]"
              variant={"secondary"}
              disabled={loadingReduxState.actionLoading}
              actionLoading={(loadingReduxState.actionLoading)}
              onClick={async () => {
                if (currentStepData?.onNextClick !== undefined) {
                  let returnonNextClick = await currentStepData?.onNextClick()
                  return returnonNextClick
                }
                return false;
              }}
            >{currentStepData?.finishBtnText ? currentStepData?.finishBtnText : t("inputFieldsTitle.finish")}</TwButton>
          )}
        </div>
      </div>
    </div>
  );
}
